import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ModuleProps } from 'pages/cadastro/permissoes/types';

export function useQueryModulos() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();

    return useQuery({
        enabled: !id,
        queryKey: ['permissoes-modulos'],
        queryFn: () =>
            requestListagem({
                url: '/security/grupousuariopermissao?application=portal',
            }).then(({ data }) => {
                const modules: ModuleProps[] = data.data;
                return modules.map((module) => ({
                    ...module,
                    permissoes: module.permissoes.map((permission) => ({
                        ...permission,
                        fgPermiteAcesso: false,
                    })),
                }));
            }),
    });
}
